export default __webpack_public_path__ + "static/media/score-polka-dot-man.7782b532.png";